<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new invoice order</small>
      </legend>
      <div>
        <form @submit.prevent="newInvoice()">
          <div class="row">
              <div class="col-md-4">
              <div class="form-group">
                <label>
                  Invoice no
                  <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control invoice_no input-rounded f-s-14" required />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>
                  Invoice date
                  <span class="text-danger">*</span>
                </label>
                <input type="date" class="form-control invoice_date input-rounded f-s-14" required />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>
                  Consignee
                  <span class="text-danger">*</span>
                </label>
                <input type="text" class="form-control consignee_name input-rounded f-s-14" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive" width="100">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(sale_product, k) in invoiceItemsrows" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, sale_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, sale_product)"></i> -->
                      </td>
                      <td>
                        <input type="text" class="form-control" v-model="sale_product.description">
                      </td>
                      <td>
                        <input
                          readonly
                          class="form-control text-right"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="sale_product.amount"
                        />
                      </td>
                      
                    </tr>
                    <tr v-show="invoiceItemsrows.length === 0">
                      <td colspan="2">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="2" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_subtotal"
                      />
                    </tr>
                    <tr>
                      <td colspan="2" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right sales_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_total"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addInvoiceItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingSale btn-rounded">
              <i class="fa fa-plus"></i> create sale order
            </button>
            <button type="button" class="btn-rounded btn-flat creatingSaleLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
import { ModelListSelect } from 'vue-search-select'
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
  computed: {
    ...mapGetters([
      "invoiceItemsrows",
    ])
  },
  methods: {
    ...mapActions(["newInvoice"]),
    ...mapMutations(["addInvoiceItems", "addContainerItems"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.invoiceItemsrows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    // calculateLineTotal(sale_product) {
    //   var total =
    //     parseFloat(sale_product.unit_price) * parseFloat(sale_product.qty);
    //   if (!isNaN(total)) {
    //     sale_product.total_price = total.toFixed(2);
    //   }
    //   this.calculateTotal();
    // },
    deleteRow(index, sale_product) {
      var idx = this.invoiceItemsrows.indexOf(sale_product);
      console.log(idx, index);
      if (idx > -1) {
        this.invoiceItemsrows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
   
};
</script>
<style scoped>
.creatingSaleLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/invoices/invoice.vue